import { Controller } from "@hotwired/stimulus"
import debounce from 'debounce'

// Connects to data-controller="autosubmit"
export default class extends Controller {
  static targets = ["search", "resetButton"]
  static classes = ["hidden"]

  initialize() {
    this.debouncedSubmit = debounce(this.debouncedSubmit.bind(this), 300)
    this.toggleResetButton();
  }

  submit(e) {
    this.element.requestSubmit()
  }

  debouncedSubmit() {
    this.submit()
    this.toggleResetButton()
  }

  reset(){
    this.element.reset()
    this.submit()
    this.toggleResetButton()
  }

  toggleResetButton() {
    if (this.hasResetButtonTarget) {
      this.resetButtonTarget.classList.toggle(this.hiddenClass, this.searchTarget.value.length === 0);
    }
  }
}
